module.exports = __webpack_public_path__ + "06_long_gold.bc9be246.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/06_long_gold.png
// module id = rd0L
// module chunks = 0